import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import './registerServiceWorker'
import '@/assets/css/tailwind.css'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import '@progress/kendo-ui'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
// import '@progress/kendo-theme-default/dist/all.css'
import '@/assets/css/all.css'

import '@progress/kendo-ui/js/messages/kendo.messages.es-ES.js'

import { Grid, GridInstaller } from '@progress/kendo-grid-vue-wrapper'

import { Scheduler, SchedulerInstaller } from '@progress/kendo-scheduler-vue-wrapper'

const datepickerOptions = {
  colors: {
    selected: '#1CCAD3',
    inRange: '#1CCAD3',
    inRangeBorder: '#1CCAD3',
    disabled: '#1CCAD3'
  },
  texts: {
    apply: 'Aceptar',
    cancel: 'Cancelar'
  },
  days: ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'],
  daysShort: ['Lun', 'Mar', 'Mie', 'Ju', 'Vi', 'Sab', 'Dom'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ]
}

Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.use(GridInstaller)
Vue.use(VueSidebarMenu)
Vue.use(SchedulerInstaller)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  components: {
    Scheduler,
    Grid
  },
  render: h => h(App)
}).$mount('#app')
